/**
 * Same rules as the backend's utils/SMS/smsParts.js (keep them in sync):
 * GSM-7 (plain English) = 160 characters in one SMS, 153 per part when longer,
 * extension characters count as two; anything else (Bangla, emoji) is Unicode
 * = 70 in one SMS, 67 per part. BulkSMSBD bills per part.
 */
const GSM7_BASIC =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?" +
  "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
const GSM7_EXTENDED = "^{}\\[~]|€\f";

const BASIC = new Set(GSM7_BASIC);
const EXTENDED = new Set(GSM7_EXTENDED);

export function countSmsParts(text = "") {
  const value = String(text);
  let gsmUnits = 0;
  let isGsm = true;
  for (const ch of value) {
    if (BASIC.has(ch)) gsmUnits += 1;
    else if (EXTENDED.has(ch)) gsmUnits += 2;
    else {
      isGsm = false;
      break;
    }
  }

  if (isGsm) {
    const parts = gsmUnits === 0 ? 0 : gsmUnits <= 160 ? 1 : Math.ceil(gsmUnits / 153);
    return { encoding: "GSM-7", units: gsmUnits, parts, perPart: gsmUnits <= 160 ? 160 : 153 };
  }

  const units = value.length;
  const parts = units === 0 ? 0 : units <= 70 ? 1 : Math.ceil(units / 67);
  return { encoding: "Unicode", units, parts, perPart: units <= 70 ? 70 : 67 };
}

/** The SMS a recipient gets: {TrackingLink} replaced by a link of the real length. */
export const previewSms = (content = "", shortLinkStyle = "full") => {
  const sampleLink = `${shortLinkStyle === "short" ? "" : "https://"}bibahobangla.com/s/AB12CD`;
  return content.replace(/{TrackingLink}/g, sampleLink);
};

export const formatBdt = (n) =>
  `৳${(Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
